import { Injectable } from '@angular/core';
import { ReportFilters } from '../../operations/dataModels/norma-order-list.model';
import { FilterSearchCriteria, Filtration, Operator } from '../dataModels';

@Injectable()

export class SharedDataService {
    private orderFilter: any = {};

    constructor() { }
    setSearchFilterInOrderList(orderCode: string) {
        (this.orderFilter as ReportFilters).IsSortingEnabled = true;
        (this.orderFilter as ReportFilters).Filtration = new Filtration();
        (this.orderFilter as ReportFilters).Filtration.SearchCriteria = [new FilterSearchCriteria('OrderCode', Operator.Equal, orderCode)];
    }
    getSearchFilterInOrderList(): ReportFilters {
        return typeof this.orderFilter == 'object' && Object.keys(this.orderFilter).length === 0 ? null : this.orderFilter;
    }

    clearOrderFilter() {
        this.orderFilter = {};
    }

}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/shared-data.service.ts